export const theme = {
  section: {
    width: '100vw',
    marginLeft: 'calc(50% - 50vw)',
    backgroundColor: '#fff',
  },
  container: {
    maxWidth: '1100px',
    padding: '20px',
    margin: '0 auto',
  },
  yellowWrapper: {
    margin: '0 auto',
    maxWidth: '900px',
    backgroundColor: '#fd0',
    borderRadius: '19px',
    padding: '30px 20px',
  },
  mainTitle: {
    fontSize: '1.5rem',
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: '25px',
    borderBottom: '2px solid black',
  },
  subTitle: {
    fontSize: '1.1rem',
    fontWeight: '900',
    textAlign: 'center',
    marginBottom: '20px',
  },
  wireWrapper: {
    display: {
      md: 'flex',
      sm: 'flex',
      xs: 'block',
    },
    flexDirection: {
      md: 'row',
      sm: 'row',
    },
    justifyContent: {
      md: 'space-around',
      sm: 'space-around',
    },
  },
  infoWrapper: {
    width: {
      md: '45%',
      sm: '55%',
    },
  },
  thumb: { textAlign: 'center', border: '1px solid black', borderRadius: '10px', padding: '10px' },
  title: {
    fontSize: '1rem',
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: '20px',
  },
  list: {
    listStyle: 'none',
    padding: '0',
  },
  text: {
    fontSize: '1rem',
  },
  solidText: {
    fontSize: '1rem',
    fontWeight: '600',
    marginBottom: '5px',
  },
  image: {
    height: 'auto',
    width: '250px',
  },
};
